function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#219653"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7519 25.6479L13.1519 22.0479C12.6827 21.5787 12.6827 20.8203 13.1519 20.3511C13.6211 19.8819 14.3795 19.8819 14.8487 20.3511L17.5319 23.0343L25.0895 14.4195C25.5215 13.9155 26.2787 13.8579 26.7803 14.2887C27.2843 14.7207 27.3431 15.4767 26.9111 15.9795L18.5111 25.5795C18.2939 25.8339 17.9795 25.9851 17.6459 25.9983C17.2823 25.9995 16.9763 25.8735 16.7519 25.6479Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 12,
  y: 14,
  width: 16,
  height: 12
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7519 25.6479L13.1519 22.0479C12.6827 21.5787 12.6827 20.8203 13.1519 20.3511C13.6211 19.8819 14.3795 19.8819 14.8487 20.3511L17.5319 23.0343L25.0895 14.4195C25.5215 13.9155 26.2787 13.8579 26.7803 14.2887C27.2843 14.7207 27.3431 15.4767 26.9111 15.9795L18.5111 25.5795C18.2939 25.8339 17.9795 25.9851 17.6459 25.9983C17.2823 25.9995 16.9763 25.8735 16.7519 25.6479Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgGreenCheck = function SvgGreenCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green-check.3101708d.svg";
export { ForwardRef as ReactComponent };